import './CreditorSummary.scss';
import { MotifIcon } from '@ey-xd/motif-react';
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import Banner, { BannerElement } from '@/components/Banner/Banner';
import { useCase } from "@/features/case/use-case";
import { useTranslation } from 'react-i18next';
import { ActiveTabsOrder } from "@/menuData";

function CreditorSummaryHeader({
  caseId,
  creditorId,
  headerData
}: {
  caseId: string;
  creditorId: string;
  headerData:any
}) {

  const {t}=useTranslation();
const data=headerData || {}
  const caseData = useCase(caseId);

  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: caseData?.caseName || t("pages.creditors.creditorSummaryBreadCrums.backToCase"),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CREDITOR}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: data?.creditorName ? data?.creditorName : "",
      url: "/",
      disabled: true,
    },
  ];

  const bannerElements: BannerElement[] = [
    {
      label: "pages.creditors.creditorSummaryBanner.creditorId",
      // value: `${propData.creditorId}`,creditorReference
      value: `${
        data?.creditorReference === null ? "-" : data?.creditorReference
      }`,
    },
    {
      label: "pages.creditors.creditorSummaryBanner.creditorType",
      value: `${
        data?.creditorType === null ? "" : data?.creditorType
      }`,
    },
    {
      label: "pages.creditors.creditorSummaryBanner.totalClaims",
      value: `${data?.totalClaims}`,
    },
  ];

  if (!caseData) {
    return null;
  }

  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      <Banner
        bannerName="pages.creditors.creditorSummaryBanner.bannerTitle"
        bannerNameValue={data?.creditorName}
        elements={bannerElements}
      />
    </>
  );
}

export default CreditorSummaryHeader;